// letters, numbers, and hyphens only
const anchorNameRegex = /[^a-z0-9-]+/g;

type Identifier = string | number;

export function getAnchorName(...identifiers: Identifier[]) {
  return (
    '--' +
    identifiers
      .map(s => String(s))
      .map(s => s.toLowerCase().replace(anchorNameRegex, '-'))
      .join('-')
  );
}
